import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const RequireAuth = () => {
  const location = useLocation();
  const token = localStorage.getItem('stack_access_token');

  // If there's no token, send them to login
  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // If authenticated, render the nested route
  return <Outlet />;
};

export default RequireAuth;
